/**
 * Alert bar module.
 *
 * Shows the alert bar when no dismissal cookie exists and
 * stores a dismissal cookie when users close the bar.
 */
function init() {
  const alertBar = document.getElementById('sagAlertBar');
  if (!alertBar) return;

  const alertId = alertBar.dataset.alertId || 'default';
  const cookieOption = alertBar.dataset.alertCookie || 'never';
  const cookieName = `alert_dismissed_${alertId}`;

  /**
   * Read a cookie value by name.
   *
   * @param {string} name
   * @returns {string|undefined}
   */
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }

    return undefined;
  }

  /**
   * Set a cookie value.
   *
   * @param {string} name
   * @param {string} value
   * @param {Date|null} expirationDate
   * @returns {void}
   */
  function setCookie(name, value, expirationDate) {
    if (expirationDate) {
      document.cookie = `${name}=${value};expires=${expirationDate.toUTCString()};path=/`;
      return;
    }

    document.cookie = `${name}=${value};path=/`;
  }

  /**
   * Repositions mobile push navigation when the alert bar is visible.
   *
   * @returns {void}
   */
  function adjustMobilePosition() {
    if (window.innerWidth < 833) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const alertBarHeight = alertBar.offsetHeight;
          const totalTop = 64 + alertBarHeight;

          const pushMenu = document.querySelector('.push__menu');
          const pushContent = document.querySelector('.push__content');

          if (pushMenu) {
            pushMenu.style.top = `${totalTop}px`;
          }

          if (pushContent) {
            const styleId = 'push-content-after-style';
            let styleElement = document.getElementById(styleId);

            if (!styleElement) {
              styleElement = document.createElement('style');
              styleElement.id = styleId;
              document.head.appendChild(styleElement);
            }

            styleElement.textContent = `.push__content::after { top: ${totalTop}px !important; }`;
          }
        });
      });

      return;
    }

    const pushMenu = document.querySelector('.push__menu');
    if (pushMenu) {
      pushMenu.style.top = '';
    }

    const styleElement = document.getElementById('push-content-after-style');
    if (styleElement) {
      styleElement.textContent = '';
    }
  }

  if (!getCookie(cookieName)) {
    alertBar.style.display = 'block';
    adjustMobilePosition();
  }

  // Debounced resize to avoid excessive recalculation.
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(adjustMobilePosition, 100);
  });

  const closeButton = document.getElementById('closeAlertBar');
  if (!closeButton) return;

  closeButton.addEventListener('click', () => {
    alertBar.style.display = 'none';

    let expirationDate = null;

    switch (cookieOption) {
      case 'never':
        expirationDate = new Date();
        expirationDate.setFullYear(expirationDate.getFullYear() + 10);
        break;
      case 'day':
        expirationDate = new Date();
        expirationDate.setTime(expirationDate.getTime() + (24 * 60 * 60 * 1000));
        break;
      case 'week':
        expirationDate = new Date();
        expirationDate.setTime(expirationDate.getTime() + (7 * 24 * 60 * 60 * 1000));
        break;
      default:
        expirationDate = new Date();
        expirationDate.setFullYear(expirationDate.getFullYear() + 10);
    }

    setCookie(cookieName, 'true', expirationDate);
    adjustMobilePosition();
  });
}

export {init as default};
